export const SAVE = 'stepOtherTugo.SAVE';
export const VALUE_CHANGED = 'stepOtherTugo.VALUE_CHANGED';
export const LOAD = 'stepOtherTugo.VALUE_LOAD';
export const NEXT = 'stepOtherTugo.NEXT';
export const RESET = 'stepOtherTugo.RESET';
export const RESET_FORM_FIELDS = 'stepOtherTugo.RESET_FORM_FIELDS';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/constants.js